import baustein from "baustein";


export default baustein.register("base-overlay", {
    render: function() {
        this.el.classList.add("overlay");
        var overlayContent = document.createElement("div");
        overlayContent.className = "overlay-content";
        var overlayClose = document.createElement("div");
        overlayClose.className = "overlay-close overlay-close-icon";
        this.el.appendChild(overlayContent);
        this.el.appendChild(overlayClose);
    },

    setContent: function(html) {
        this.el.querySelector(".overlay-content").innerHTML = html;
    },
});
